import { createAction } from '@reduxjs/toolkit';

export const addVacancies = createAction('vacancies/add');
